// extracted by mini-css-extract-plugin
module.exports = {"form":"warehouseChangeReport_form__3IsTv","content":"warehouseChangeReport_content__EAgRR","total":"warehouseChangeReport_total__2VgSv"};